import { render, staticRenderFns } from "./SupplierInvoiceImports.vue?vue&type=template&id=5278273a"
import script from "./SupplierInvoiceImports.vue?vue&type=script&lang=js"
export * from "./SupplierInvoiceImports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports